import React from "react";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import Avatar from "../../assets/images/Profile-thumbnail-small.svg";

export default function AllStudentForInstructor({ detailNavigate, students }) {

  const auth = useSelector((state) => state.auth);

  const courseList = Array.isArray(students) ? students : [];

  return (
    <>
      <article className="card-default-style mb-10 px-10">
        {courseList?.length === 0 && (
          <div className="alert alert-info">
            No {auth?.role === "Admin" ? "Instructors" : "Students"} available.
          </div>
        )}
        <div className="instructor-warraper px-10">
          {courseList?.map((student) => (
            <div className="instructor" key={student.id}>
              <Link
                to={`${detailNavigate}?id=${student.id}`}
                className=" d-flex justify-content-between align-items-center"
              >
                <div className="instructor-left d-flex align-items-center flex-shrink-0">
                  <Image
                    src={
                      process.env.REACT_APP_GALLERY_URL +
                      student.profile_picture
                    }
                    alt={student.full_name}
                    className="instructor-img rounded-circle me-6 flex-shrink-0"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = Avatar; // Fallback to default image
                    }}
                  />
                  <div>
                    <h5 className="ah-text-sm fw-semibold text-black mb-6">
                      {student?.full_name || "Not Provided"}
                    </h5>
                    <p className="ah-text-xs fw-semibold mb-0">
                      {student.email}
                    </p>
                  </div>
                </div>
                <span className="theme-color ah-text-xs fw-semibold">
                  See Details
                </span>
              </Link>
            </div>
          ))}
        </div>
      </article>
    </>
  );
}
